import { Card, Row, Col, Statistic, Typography } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  AreaChartOutlined,
  SwapOutlined,
  PercentageOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

const { Title } = Typography;

interface KPIData {
  total_control_points: number;
  open_control_points: number;
  closed_control_points: number;
  total_detected_surface: number;
  total_converted_surface: number;
  conversion_rate: number;
  average_days_to_close: number;
}

interface Props {
  data: KPIData;
  loading?: boolean;
  countryName?: string;
}

export const DashboardKPIs = ({ data, loading, countryName }: Props) => {
  return (
    <Card loading={loading}>
      <Title level={4}>
        {countryName ? `Indicadores Clave - ${countryName}` : "Indicadores Clave"}
      </Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic
              title="Total Puntos de Control"
              value={data.total_control_points}
              prefix={<AreaChartOutlined />}
              valueStyle={{ color: "#1890ff" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic
              title="Puntos Abiertos"
              value={data.open_control_points}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: "#52c41a" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic
              title="Puntos Cerrados"
              value={data.closed_control_points}
              prefix={<CloseCircleOutlined />}
              valueStyle={{ color: "#ff4d4f" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic
              title="Superficie Detectada"
              value={data.total_detected_surface}
              precision={2}
              suffix="ha"
              prefix={<AreaChartOutlined />}
              valueStyle={{ color: "#faad14" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic
              title="Superficie Convertida"
              value={data.total_converted_surface}
              precision={2}
              suffix="ha"
              prefix={<SwapOutlined />}
              valueStyle={{ color: "#52c41a" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic
              title="Tasa de Conversión"
              value={data.conversion_rate}
              precision={2}
              suffix="%"
              prefix={<PercentageOutlined />}
              valueStyle={{ color: "#1890ff" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <Statistic
              title="Días Promedio para Cierre"
              value={data.average_days_to_close}
              precision={1}
              suffix="días"
              prefix={<ClockCircleOutlined />}
              valueStyle={{ color: "#722ed1" }}
            />
          </Card>
        </Col>
      </Row>
    </Card>
  );
};
